<div class="blogs-container">
    <div class="blog-container">
        <div [innerHTML]="blog.innerHtml"></div>
    </div>
</div>
